import { Component, Input, EventEmitter, Output, HostListener } from '@angular/core';
import { DataPointsService } from '@datapoints';
import { __i18n } from '@localisation';
import { PlantService } from '@plants';
import { SystemsService } from '@systems';


@Component({
    selector: 'benchmark-datapoint-row',
    template: `
    <clx-row has="full-size-columns big-layout">
        <clx-item type="title-bar">
            <a
                class="icon fa fa-ellipsis-v toolbar-button"
                is="move-datapoints-button"
                [attr.test-id]="testId + '.move-datapoint.button'"
                title="Change Position"
                i18n-title="@@dashboard.editor.tile-properties.actions.title.change-position"
            ></a>
            <clx-label>{{viewName}}</clx-label>
            <a
                *ngIf="!showDetails"
                class="default icon fa fa-caret-down toolbar-button add-datapoints-button"
                (click)="openDetails()"
                [attr.test-id]="testId + '.open-details.button'"
                title="open details"
                i18n-title="@@dashboard.editor.tile-properties.actions.title.open-details"
            ></a>
            <a
                *ngIf="showDetails"
                class="default icon fa fa-caret-up toolbar-button add-datapoints-button"
                (click)="closeDetails()"
                [attr.test-id]="testId + '.close-details.button'"
                title="close details"
                i18n-title="@@dashboard.editor.tile-properties.actions.title.close-details"
            ></a>
            <a
                class="default icon fa fa-minus-square toolbar-button add-datapoints-button"
                (click)="deleteDatapoint()"
                [attr.test-id]="testId + '.delete-axis.button'"
                title="Delete Datapoint"
                i18n-title="@@dashboard.editor.tile-properties.actions.title.delete-datapoint"
            ></a>
        </clx-item>
        <clx-item  [class.input-color-item]="chartType !== 'circulargauge'">
            <clx-input [(ngModel)]="data.name" #name (blur)="change(data, name)" [test-id]="testId + '.title.input'" (dragstart)="startDragInput($event)" (drag)="startDragInput($event)" [draggable]="true">
                <clx-tooltip direction="left">
                    <h4 i18n="@@dashboard.editor.tile-properties.available-tokens">Available Tokens:</h4>
                    <ul class="datapoint-tokens">
                        <li (click)="name.addToken('[SiteName]')">[SiteName]</li>
                        <li (click)="name.addToken('[SiteDescription]')">[SiteDescription]</li>
                        <li (click)="name.addToken('[SiteAddress]')">[SiteAddress]</li>
                        <li (click)="name.addToken('[SiteZipCode]')">[SiteZipCode]</li>
                        <li (click)="name.addToken('[SiteCity]')">[SiteCity]</li>
                        <li (click)="name.addToken('[SiteState]')">[SiteState]</li>
                        <li (click)="name.addToken('[SiteCountry]')">[SiteCountry]</li>
                        <li (click)="name.addToken('[SitePhone]')">[SitePhone]</li>
                        <li (click)="name.addToken('[TenantName]')">[TenantName]</li>
                        <li (click)="name.addToken('[SystemName]')" *ngIf="isSystemMode" test-id="dashboard.editor.tile-properties.window.title.token.system-name">[SystemName]</li>
                        <li (click)="name.addToken('[SystemDescription]')" *ngIf="isSystemMode" test-id="dashboard.editor.tile-properties.window.title.token.system-description">[SystemDescription]</li>
                        <li (click)="name.addToken('[SystemAddress]')" *ngIf="isSystemMode" test-id="dashboard.editor.tile-properties.window.title.token.system-address">[SystemAddress]</li>
                        <li (click)="name.addToken('[SystemZipCode]')" *ngIf="isSystemMode" test-id="dashboard.editor.tile-properties.window.title.token.system-zip">[SystemZipCode]</li>
                        <li (click)="name.addToken('[SystemCity]')" *ngIf="isSystemMode" test-id="dashboard.editor.tile-properties.window.title.token.system-city">[SystemCity]</li>
                        <li (click)="name.addToken('[SystemCountry]')" *ngIf="isSystemMode" test-id="dashboard.editor.tile-properties.window.title.token.system-country">[SystemCountry]</li>
                        <li (click)="name.addToken('[SystemPhone]')" *ngIf="isSystemMode" test-id="dashboard.editor.tile-properties.window.title.token.system-phone">[SystemPhone]</li>
                        <li (click)="name.addToken('%t')">%t (Display name)</li>
                        <li (click)="name.addToken('%T')">%T (Instance name)</li>
                        <li (click)="name.addToken('%N')">%N (Member name)</li>
                        <li (click)="name.addToken('%u')">%u (Unit text)</li>
                    </ul>
                </clx-tooltip>
            </clx-input>
            <clx-color *ngIf="chartType !== 'circulargauge'" [(ngModel)]="data.color"  (valueChanged)="change(data)"></clx-color>
        </clx-item>
    </clx-row>
   
    <clx-row is="datapoint-detail-row" *ngIf="showDetails"  has="full-size-columns big-layout">
        <clx-label>DatapointId:</clx-label>
        <clx-item>
            <clx-input name="datapointId" [(ngModel)]="data.datapointId" (blur)="change(data)" (dragstart)="startDragInput($event)" (drag)="startDragInput($event)" [draggable]="true"></clx-input>
        </clx-item>
    </clx-row>
    <clx-row is="datapoint-detail-row" *ngIf="showDetails"  has="full-size-columns big-layout">
        <clx-label>PlantId:</clx-label>
        <clx-item>
            <clx-input name="plantId" [(ngModel)]="data.plantId" (blur)="change(data)" (dragstart)="startDragInput($event)" (drag)="startDragInput($event)" [draggable]="true"></clx-input>
        </clx-item>
    </clx-row>
    `,
    standalone: false
})
export class DatapointRowComponent{
    constructor(private datapointService : DataPointsService, private systemService: SystemsService, private plantService: PlantService){}

    public viewName : string = '';

    @Input()
    public data : any = {
        datapointId : ''
    };

    private innerAvailableAxes: any[] = [];

    public showDetails: boolean = false;

  

    @Input()
    public showAxes: boolean = false;

    @Input()
    public isSystemMode: boolean = false;

    @Input()
    public changeHandler: any;

    @Input()
    public chartType: string;

    @Input('test-id')
    public testId: any;

    @Input()
    public systemId: string;

    @Output()
    public deleted : EventEmitter<any> = new EventEmitter();


    public startDragInput(e) {
        return false;
    }


    public async convertPlantIdBySystemId(plantId: string) {
        if(this.systemService.isSystemPlantToken(plantId) && !this.systemId){
            console.error('Can not convert plant token, becaouse systemId is not set!', plantId, this.systemId, this)
            return;
        }

        if(this.systemService.isSystemPlantToken(plantId)){
            return await this.systemService.getPlantSystemId(plantId, this.systemId);
        }
        return plantId;
    }

    public deleteDatapoint(){
        this.deleted.emit({
            datapointId : this.data.datapointId,
            plantId :  this.data.plantId,
        });
    }

    public axes : any[] = [];
    private subscriptions = [];

    private createAxes(){
        this.showAxes = false;
        this.checkIfDatapointAxiseExists();
        this.showAxes = true;
    }

    private checkIfDatapointAxiseExists(){
        if(!this.axes.find((axis) => {
            return  axis.value ===  this.data.axis
        })){
            this.data.axis = '';
        }
    }

    public async ngAfterViewInit(){
    
        let dataPointDetails;
        let plantId;
        let plantInfo;
        const plantNotExistText = __i18n('Cannot access plant to convert datapoint name!', 'ashboard.editor.tile-properties.datapoint-row.canot-access-datapointname');
        
        try {
            if(this.data.plantId && this.data.datapointId){
                plantId = await this.convertPlantIdBySystemId(this.data.plantId);
                dataPointDetails = await this.datapointService.getDataPointDetails(plantId + ';' + this.data.datapointId);
            }else if(this.data.id){
                plantId = await this.convertPlantIdBySystemId(this.data.id);
                dataPointDetails = await this.datapointService.getDataPointDetails(plantId);
            }else{
                console.warn('No Ids defined! [DatapointRowComponent.ngAfterViewInit]')
                return;
            }
            plantInfo = await this.plantService.getPlant(plantId);
        }catch(e){
            this.viewName = plantNotExistText;
            return;
        }
        if(!dataPointDetails){
            this.viewName = plantNotExistText;
            return;
        }
        
        this.setViewName(plantInfo, dataPointDetails);
       
        this.data = {...this.data, ...dataPointDetails}
    }

    private setViewName(plantInfo, dataPointDetails) {
        if(plantInfo && dataPointDetails) {
            if (dataPointDetails.descText) {
                this.viewName = plantInfo.name + ' - ' + dataPointDetails.descText.replace(/\n/gm, ' ');
            } else if (dataPointDetails.objectName && dataPointDetails.memberName && dataPointDetails.descriptionName) {
                this.viewName  = plantInfo.name + ' - ' + dataPointDetails.objectName + ' ' +  dataPointDetails.descriptionName + ' - ' + dataPointDetails.memberName;
            } else if (dataPointDetails.objectName && dataPointDetails.memberName) {
                this.viewName  = plantInfo.name + ' - ' + dataPointDetails.objectName + ' - ' + dataPointDetails.memberName;
            } else {
                this.viewName  = plantInfo.name + ' - ' + dataPointDetails.name;
            }
        }
    }

    private changeTimer: any;
    public change(value?, element?){
        clearTimeout(this.changeTimer);
        this.changeTimer = setTimeout(() => {
            this.valueChanged.emit(this.data);
        }, 300);
       
    }

    

    public setAxis(axis){
        this.data.axis = axis;
        this.valueChanged.emit(this.data);
    }

    public openDetails() {
        this.showDetails = true;
    }

    public closeDetails() {
        this.showDetails = false;
    }

    @HostListener('mousedown', ['$event'])
    public onMouseDown(e: any){
        const source = e.srcElement.nodeName.toLowerCase();
        this.inputSelectionChanged.emit(source === 'input')
    }


    @Output()
    public valueChanged : EventEmitter<any> = new EventEmitter();


    @Output()
    public inputSelectionChanged : EventEmitter<any> = new EventEmitter();
}